const NAKAMA_CONFIG = {
    serverKey: 'ij91f8hCNl8s',
    serverHost: 'nakama-production.us-east1.nakamacloud.io',
    serverPort: 443,
    serverSSL: true,
    trace: false
};

export default NAKAMA_CONFIG;